import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';

/**
 * Header 검색 버튼 선택시 표시 되는 Input
 */
const SearchInputBlock = styled.input.attrs({
    type: 'text',
    placeholder: "검색어를 입력해주세요."
})`
    width: ${props => props.width};
    padding: ${props => props.padding};
    height: ${props => props.height || '40px'};
    margin: 0;
    font-size: ${isMobileOnly?"11px":"14px"};
    background-color: ${props => props.bgColor || 'transparent'};
    border: ${props => props.border};
    border-radius: ${props => props.borderRadius || '0'};
    border-bottom: ${props => props.borderBottom};
    opacity: ${props => props.active ? '1' : '0'};
    -webkit-transition: width .4s,padding .4s;
    -o-transition: width .4s,padding .4s;
    transition: width .4s,padding .4s;
    float: left;

    ::-webkit-input-placeholder {
        color: #111
    }

    ::-moz-placeholder {
        color: #111
    }
    
    ::-ms-input-placeholder {
        color: #111
    }

    ::placeholder {
        color: #111
    }
    :focus {
        outline: 0
    }
`;

const SearchInput = ({ active, width, padding, height, borderRadius, bgColor, borderBottom, onChange, enterPress, inputRef }) => {

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            //   console.log('do validate')
            enterPress();
        }
    }

    const onChangeInput = (e) => {
        onChange(e)
    }
    // console.log("borderRadius " + borderRadius)
    return (
        <SearchInputBlock 
            id="searchInput"
            active={active}
            width={width} height={height}
            padding={padding}
            borderRadius={borderRadius} bgColor={bgColor}
            borderBottom={borderRadius ? "1px solid #ececec" : "2px solid #111"}
            border={borderRadius ? "1px solid #ececec" : "none"}
            onChange={onChange}
            onKeyPress={handleKeyDown}
            ref = {inputRef}/>
    );
};

export default SearchInput;
